import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setDeleteRequestId,
  setDeleteMaskedData,
  setDeleteOtpToMobile,
} from '../../../modules/delete-account/actions/creators'
import { doVerifyOtp, doRequestOtp } from '../../../controllers/DeleteAccount'

const mapStateToProps = reduxState => {
  const { deleteAccount, auth } = reduxState
  const { accessToken } = auth
  const { maskedData, deleteRequestId, otpToMobile } = deleteAccount

  return {
    maskedData,
    accessToken,
    otpToMobile,
    deleteRequestId,
    doVerifyOtp,
    doRequestOtp,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setDeleteRequestId,
      setDeleteMaskedData,
      setDeleteOtpToMobile,
      replace,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
